module.exports = __webpack_public_path__ + "img/brush-rose.553bdf06.png";